import axios from 'axios';
import vopayApi from '@/services/api.config';
import { useClientData } from '@/providers/ClientData.provider';
import { SupportedCurrencies } from 'vopay';
import { useState } from 'react';
import { useDataFetchIndicator } from '..';

const { api } = vopayApi;

export type Balance = {
  AccountBalance: number;
  AvailableFunds: number;
  Currency: SupportedCurrencies;
  PendingFunds: number;
  Reserve: number;
};

export default function useAccountBalance() {
  const source = axios.CancelToken.source();
  const [balance, setBalance] = useState<Balance>();
  const [, setPending] = useDataFetchIndicator();

  const {
    response: { AccountID },
  } = useClientData();

  async function fetchBalance(currency: string) {
    try {
      setPending(true);

      const response = await api.postAccountBalance(
        {
          PortalUser: AccountID,
          Currency: currency,
        },
        source,
      );

      if (response.ErrorMessage) {
        throw new Error(response.ErrorMessage);
      }

      setBalance({
        AccountBalance: parseFloat(response.AccountBalance),
        AvailableFunds: parseFloat(response.AvailableFunds),
        Currency: response.Currency,
        PendingFunds: parseFloat(response.PendingFunds),
        Reserve: parseFloat(response.Reserve),
      });
    } catch (err) {
      console.error(err);

      if (err instanceof Error) throw err;

      throw new Error('An error occurred while fetching account balances');
    } finally {
      setPending(false);
    }
  }

  return {
    fetchBalance,
    balance,
  };
}
